module.exports = __webpack_public_path__ + "img/slide-22.f3ac5d04.jpg";